import { render, staticRenderFns } from "./goodsCategories.vue?vue&type=template&id=27eb6b0c"
import script from "./goodsCategories.vue?vue&type=script&lang=js"
export * from "./goodsCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports